import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Breadcrumb";
import ViewProfileLayer from "../components/ViewProfileLayer";
import MasterLayout from "../masterLayout/MasterLayout";
import UserServices from "../services/api/user";
import { toast } from "react-toastify";

const ViewProfilePage = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Carregar dados do perfil do usuário
  useEffect(() => {
    const loadUserProfile = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // SEMPRE buscar da API para ter dados atualizados (especialmente avatar_url)
        console.log('📥 ViewProfilePage - Buscando perfil da API...');
        const response = await UserServices.getProfile();
        const profileData = response.data;
        
        console.log('✅ ViewProfilePage - Perfil obtido da API:', {
          id: profileData.id,
          name: profileData.name,
          avatar_url: profileData.avatar_url,
          hasAvatar: !!profileData.avatar_url
        });
        
        setUserProfile(profileData);
        
        // Atualizar localStorage com dados atualizados (incluindo avatar_url)
        const existingUserData = localStorage.getItem('user') || localStorage.getItem('user_data');
        if (existingUserData) {
          try {
            const parsedUser = JSON.parse(existingUserData);
            const mergedUser = { ...parsedUser, ...profileData };
            localStorage.setItem('user', JSON.stringify(mergedUser));
            localStorage.setItem('user_data', JSON.stringify(mergedUser));
            console.log('💾 ViewProfilePage - localStorage atualizado com avatar_url:', mergedUser.avatar_url);
            
            // Disparar evento para atualizar header
            window.dispatchEvent(new CustomEvent('userAvatarUpdated'));
          } catch (e) {
            console.error('❌ Erro ao atualizar localStorage:', e);
          }
        } else {
          // Se não tiver no localStorage, criar
          localStorage.setItem('user', JSON.stringify(profileData));
          localStorage.setItem('user_data', JSON.stringify(profileData));
          console.log('💾 ViewProfilePage - localStorage criado com avatar_url:', profileData.avatar_url);
          
          // Disparar evento para atualizar header
          window.dispatchEvent(new CustomEvent('userAvatarUpdated'));
        }
      } catch (error) {
        console.error('❌ Erro ao carregar perfil:', error);
        console.error('❌ Detalhes do erro:', error.response?.data);
        
        // Em caso de erro, tentar usar localStorage como fallback
        const localUser = localStorage.getItem('user');
        if (localUser) {
          try {
            const parsedUser = JSON.parse(localUser);
            console.log('⚠️ ViewProfilePage - Usando dados do localStorage como fallback');
            setUserProfile(parsedUser);
          } catch (e) {
            console.error('❌ Erro ao parsear usuário do localStorage:', e);
            setError(error.message || 'Erro desconhecido ao carregar perfil');
            toast.error(`Erro ao carregar dados do perfil: ${error.message}`);
          }
        } else {
          setError(error.message || 'Erro desconhecido ao carregar perfil');
          toast.error(`Erro ao carregar dados do perfil: ${error.message}`);
        }
      } finally {
        setLoading(false);
      }
    };

    loadUserProfile();
  }, []);

  if (loading) {
    return (
      <MasterLayout>
        <Breadcrumb 
          title="Meus Dados" 
          items={[
            { label: 'Configurações', path: '/settings' }
          ]}
        />
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-3">Carregando seus dados...</p>
          </div>
        </div>
      </MasterLayout>
    );
  }

  if (error) {
    return (
      <MasterLayout>
        <Breadcrumb 
          title="Meus Dados" 
          items={[
            { label: 'Configurações', path: '/settings' }
          ]}
        />
        <div className="container-fluid">
                  <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Erro ao carregar perfil!</h4>
          <p><strong>Mensagem:</strong> {error}</p>
          <hr />
          <div className="d-flex gap-2">
            <button 
              className="btn btn-outline-danger"
              onClick={() => window.location.reload()}
            >
              Tentar Novamente
            </button>
            <button 
              className="btn btn-outline-secondary"
              onClick={() => window.location.href = '/'}
            >
              Voltar ao Login
            </button>
          </div>
        </div>
        </div>
      </MasterLayout>
    );
  }

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb 
          title="Meus Dados" 
          items={[
            { label: 'Configurações', path: '/settings' }
          ]}
        />

        {/* ViewProfileLayer */}
        <ViewProfileLayer 
          user={userProfile} 
          onUserUpdate={(updatedUser) => {
            setUserProfile(updatedUser);
            // Atualizar localStorage também
            if (updatedUser) {
              const localUser = localStorage.getItem('user') || localStorage.getItem('user_data');
              if (localUser) {
                try {
                  const parsedUser = JSON.parse(localUser);
                  const mergedUser = { ...parsedUser, ...updatedUser };
                  localStorage.setItem('user', JSON.stringify(mergedUser));
                  localStorage.setItem('user_data', JSON.stringify(mergedUser));
                } catch (e) {
                  console.error('Erro ao atualizar localStorage:', e);
                }
              }
            }
          }}
        />
      </MasterLayout>
    </>
  );
};

export default ViewProfilePage;
